module.exports = __webpack_public_path__ + "assets/img/tag_special.e29f0114.png";